import React, { useState, useEffect }from "react";
import LazyLoad from 'react-lazyload';
import styled from "@emotion/styled";
import { CategoryHolder } from "./CategoryHolder";
import { VillaCategoryHolder } from "./VillaCategoryHolder";
import { TrustpilotLocaleMap } from "../Data/APIData";
import { LoadingAnimation } from "./LoadingAnimation";
import { PopularVillas } from "./PopularVillas";
import TrustBox from "./Trustpilot.js";
import { compose } from "recompose";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { USPInner } from "./USPInner";

const ContentContainer = styled.div`
    padding: 4em 1em;
    max-width:1600px;
    margin:auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    
    @media (max-width:767px){
        display:block;
        padding: 4em 0;
    }
`;

const stripTags = (html) => {
    return html.replace(/(<([^>]+)>)/ig,"");
}

const ContentFrontpageInnerComponent = (props) => {
    const [mobile, setMobile] = useState(props.mobile);

    const resizeHandler = (e) => {
        setMobile(e.detail.properties.mobile);
    }
    
    useEffect( () => {
            document.addEventListener("CheckWindowResize", resizeHandler);
            return () => {
                document.removeEventListener("CheckWindowResize", resizeHandler);
            };
        }, [mobile, setMobile]
    );

    const categoriesData = (props) => {
        const { t, r, assetsBaseUrl } = props;

        return [
            {
                title: t('costabrava'),
                summary: false,
                image: assetsBaseUrl + "/assets/img/front/costabrava.jpg",
                link:  r('show_region', {country: t('spain').toLowerCase(), region: 'costa-brava'})
            },
            {
                title: t( 'catalonia'),
                summary: false,
                image: assetsBaseUrl + "/assets/img/front/catalonia.jpg",
                link: r('show_region', {country: t('spain').toLowerCase(), region: 'catalunya'})
            },
            {
                title: t('costablanca'),
                summary: false,
                image: assetsBaseUrl + "/assets/img/front/costablanca.jpg",
                link: r('show_region', {country: t('spain').toLowerCase(), region: 'costa-blanca'})
            },
            {
                title: t('lloretdemar'),
                summary: false,
                image: assetsBaseUrl + "/assets/img/front/lloretdemar.jpg",
                link: r('show_city', {country: t('spain').toLowerCase(), region: 'costa-brava', city: 'lloret-de-mar'})
            }
        ];
    }

    const villaCategoriesData = (props) => { 
        const { t , r, assetsBaseUrl, webpSupported} = props;
        return [
            {
                title: t('villasbeach'),
                count: 1091,
                image: assetsBaseUrl + "/assets/img/VillasBeach." + (( webpSupported )  ? 'webp' : 'jpg'),
                link: r('search', {query: 'distanceBeach/1'}) 
            },
            {
                title: t('villaspool'),
                count: 1460,
                image: assetsBaseUrl + "/assets/img/VillasWithPool." + (( webpSupported )  ? 'webp' : 'jpg'),
                link: r('search', {query: 'poolType/private'})
            },
            {
                title: t('villaspet'),
                count: 478,
                image: assetsBaseUrl + "/assets/img/VillasForPets." + (( webpSupported )  ? 'webp' : 'jpg'),
                link: r('search', {query: 'petsAllowed/1'})
            },
            {
                title: t('villas_for_youngsters'),
                count: 1051,
                image: assetsBaseUrl + "/assets/img/VillasForGroupsOfYoungsters." + (( webpSupported )  ? 'webp' : 'jpg'),
                link: r('search', {query: 'youngstersAllowed/1'})
            }
            ,
            {
                title: t('large_villas_for_families'),
                count: 736,
                image: assetsBaseUrl + "/assets/img/VillasForFamilies." + (( webpSupported )  ? 'webp' : 'jpg'),
                link: r('search', {query: 'numBedrooms/4'})
            }
            ,
            {
                title: t('find_villa_in_spain'),
                count: 1697,
                image: assetsBaseUrl + "/assets/img/VillasInSpain." + (( webpSupported )  ? 'webp' : 'jpg'),
                link: r('search', {query: 'country/spain'})
            }
        ];
    }
    const  { t, assetsBaseUrl } = props;
    return(
        <div className="relative">
            <div>
                <div className="bg-white">
                    <ContentContainer className="pt-4">
                        { !mobile && (
                            <div className="bg-white">
                                <ContentContainer className="pt-0">
                                    <h2 className="px-3 width-100 text-center font-w600">{t('villasmeetneeds')}</h2>
                                    {villaCategoriesData(props).map((item, index) => {
                                        return <VillaCategoryHolder
                                            key={index}
                                            title={item.title}
                                            count={item.count}
                                            image={item.image}
                                            link={item.link}
                                        />
                                    })}
                                </ContentContainer>
                            </div> ) 
                        }
                        <div className="bg-white">
                            <h2 className="px-3 width-100 text-center font-w600">{t('popularvillas')}</h2>
                            <PopularVillas 
                            count="6" 
                            villaweek={true} 
                            slideshowImages={props.slideshowImages}
                            slideshowImagesPreloadCount={props.slideshowImagesPreloadCount}
                            slideshowImagesLazyloadNext={props.slideshowImagesLazyloadNext}
                            villanew={true} 
                            villarecommended={true}
                            mobile={mobile}
                            tablet={props.tablet}
                            currency={props.currency}
                            data={props.popularVillas}
                            />
                        </div>
                    </ContentContainer>
                </div>
                { (!mobile && false) && 
                <LazyLoad once placeholder={<LoadingAnimation className="width-100"/>}>
                    <img className="width-100" src={assetsBaseUrl + "/assets/img/panorama-front.jpg"} alt="panorama" />
                </LazyLoad>
                }
            </div>
            { (false) &&
            <LazyLoad once placeholder={<LoadingAnimation className="width-100"/>}>
                <div className="bor-solid bor-orange2 bor-l-no bor-r-no bor-thin " style={{backgroundColor: "#F0F2F80"}} ><USPInner  {...props} /></div>
            </LazyLoad>
            }
            { !mobile && ( 
                <div>
                    <LazyLoad once placeholder={<LoadingAnimation className="width-100"/>}>
                    <div className="bg-white" style={{paddingTop:'.8em'}}>
                        <ContentContainer>
                            <h2 className="px-3 width-100 text-center font-w600-force h2">{t('popularholidaydestinations')}</h2>
                            {categoriesData(props).map((item, index) => {
                                return <CategoryHolder
                                    key={index}
                                    title={item.title}
                                    summary={item.summary}
                                    image={item.image}
                                    link={item.link}
                                />
                            })}
                        </ContentContainer>
                    </div>
                    </LazyLoad>
                </div>)}
        </div>
    );
}

export const ContentFrontpageInner = compose(
    withTranslator,
    withFosRouter
)(ContentFrontpageInnerComponent);
